module.exports = __webpack_public_path__ + "static/media/align-right.81bcd78d.svg";